import { render } from "./array_text.vue?vue&type=template&id=48fd7fb4"
import script from "./array_text.vue?vue&type=script&lang=js"
export * from "./array_text.vue?vue&type=script&lang=js"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__